import React from 'react';

import { Selectable, SelectableInfo } from '@vestahealthcare/common/enums/Enum';
import { translate } from '@vestahealthcare/common/i18n';
import { FilterSelectable, PodConfig } from '@vestahealthcare/common/models';

import { FilterItem, Select } from 'styleguide-v2';

import { getFilterItem } from 'dash/src/utils/filterUtils';

export type PODShuffleResultsFilters = {
  month?: FilterItem;
  podId?: FilterItem;
  status?: FilterItem;
};

type Props = {
  data: {
    monthOptions: Selectable[];
    podConfigs: SelectableInfo<PodConfig>[];
    statusOptions: Selectable[];
  };
  filters?: PODShuffleResultsFilters;
  loading?: boolean;
  onChange: (filters: PODShuffleResultsFilters) => void;
};

export const PODShuffleResultsFilterBar = ({
  data,
  filters,
  loading,
  onChange,
}: Props) => (
  <>
    <Select
      data-cy="pod-shuffle-results-month"
      disableClearable
      items={data.monthOptions}
      onChange={(month?: Selectable) =>
        onChange({
          ...filters,
          month: month
            ? getFilterItem(translate('pods.shuffle.results.month'), month)
            : undefined,
        })
      }
      placeholder={translate('pods.shuffle.results.selectMonth')}
      placeholderV2
      size="xs"
      value={
        data.monthOptions.find(
          (option) =>
            option.value ===
            (filters?.month?.value as FilterSelectable<string>)?.value,
        ) || null
      }
    />
    <Select
      data-cy="pod-shuffle-results-pod"
      items={data.podConfigs}
      loading={loading}
      onChange={(pod: SelectableInfo<PodConfig>) =>
        onChange({
          ...filters,
          podId: pod
            ? getFilterItem(translate('pods.shuffle.results.pod'), pod)
            : undefined,
        })
      }
      placeholder={translate('pods.shuffle.results.selectPod')}
      placeholderV2
      size="xs"
      value={
        data.podConfigs.find(
          (option) =>
            option.value ===
            (filters?.podId?.value as FilterSelectable<string>)?.value,
        ) || null
      }
    />
    <Select
      data-cy="pod-shuffle-results-status"
      items={data.statusOptions}
      onChange={(status?: Selectable) =>
        onChange({
          ...filters,
          status: status
            ? getFilterItem(translate('pods.shuffle.results.status'), status)
            : undefined,
        })
      }
      placeholder={translate('pods.shuffle.results.selectStatus')}
      placeholderV2
      size="xs"
      value={
        data.statusOptions.find(
          (option) =>
            option.value ===
            (filters?.status?.value as FilterSelectable<string>)?.value,
        ) || null
      }
    />
  </>
);
